import React from 'react'
import Select from 'react-select'
import axios from 'axios'
import { URL } from '../../util/ambienteActions'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { estados } from '../../util/constantsUtil'
import { showSuccessMsg, showAlertMsg } from '../../util/messagesUtil'
import salvarPontosEmbarque from '../../actions/pontoEmbarque/salvarPontosEmbarque'
import listarPontosEmbarquePorEmpresaCidade from '../../actions/pontoEmbarque/listarPontosEmbarquePorEmpresaCidade'
import excluirPontoEmbarque from '../../actions/pontoEmbarque/excluirPontoEmbarque'
import editarPontoEmbarque from '../../actions/pontoEmbarque/editarPontoEmbarque'
import { connect } from 'react-redux'

class ModalCadastrarPontoEmbarque extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      estadoSelecionado: null,
      cidadeSelecionada: props.cidadePreSelecionada
        ? { value: props.cidadePreSelecionada.id, label: `${props.cidadePreSelecionada.nome}-${props.cidadePreSelecionada.uf}` }
        : null,
      cidadesOpcoes: [],
      textoPonto: '',
      pontosNovos: [],
      pontosExistentes: [],
      editandoId: null,
      textoEdicao: '',
      carregando: false
    }
  }

  componentDidMount() {
    if (this.props.cidadePreSelecionada) {
      this.carregarPontosExistentes(this.props.cidadePreSelecionada.id)
      const estado = estados.find(e => e.uf === this.props.cidadePreSelecionada.uf)
      if (estado) {
        this.setState({ estadoSelecionado: { value: estado.uf, label: `${estado.nome}-${estado.uf}` } })
        this.buscarCidadesPorEstado(estado.uf)
      }
    }
  }

  buscarCidadesPorEstado(uf) {
    const url = `${URL}/public/cidades/${uf}`
    axios.get(url, SLOW_REQUEST_CONFIG).then(response => {
      if (response && response.data) {
        this.setState({
          cidadesOpcoes: response.data.map(c => ({ value: c.id, label: `${c.nome}-${c.uf}` }))
        })
      }
    })
  }

  carregarPontosExistentes(cidadeId) {
    if (!cidadeId || !this.props.empresaId) return
    const url = `${URL}/ponto-embarque/empresa/${this.props.empresaId}/cidade/${cidadeId}`
    axios.get(url, SLOW_REQUEST_CONFIG).then(response => {
      if (response && response.data) {
        this.setState({ pontosExistentes: response.data })
      }
    })
  }

  handleEstado(estadoOpt) {
    this.setState({
      estadoSelecionado: estadoOpt,
      cidadeSelecionada: null,
      cidadesOpcoes: [],
      pontosExistentes: [],
      pontosNovos: []
    })
    if (estadoOpt) this.buscarCidadesPorEstado(estadoOpt.value)
  }

  handleCidade(cidadeOpt) {
    this.setState({ cidadeSelecionada: cidadeOpt, pontosNovos: [], pontosExistentes: [] })
    if (cidadeOpt) this.carregarPontosExistentes(cidadeOpt.value)
  }

  incluirPonto() {
    const nome = this.state.textoPonto.trim()
    if (!nome) return
    this.setState(prev => ({
      pontosNovos: [...prev.pontosNovos, nome],
      textoPonto: ''
    }))
  }

  removerNovo(idx) {
    this.setState(prev => ({
      pontosNovos: prev.pontosNovos.filter((_, i) => i !== idx)
    }))
  }

  salvar() {
    if (!this.state.cidadeSelecionada) {
      showAlertMsg('Selecione uma cidade antes de salvar.')
      return
    }
    if (this.state.pontosNovos.length === 0) {
      showAlertMsg('Adicione ao menos um ponto de embarque antes de salvar.')
      return
    }
    const comando = {
      cidadeId: this.state.cidadeSelecionada.value,
      empresaId: this.props.empresaId,
      pontosNovos: this.state.pontosNovos
    }
    this.props.salvarPontosEmbarque(comando)
      .then(() => {
        showSuccessMsg('Pontos de embarque salvos com sucesso')
        this.setState({ pontosNovos: [] })
        this.carregarPontosExistentes(this.state.cidadeSelecionada.value)
      })
      .catch(() => showAlertMsg('Erro ao salvar pontos de embarque.'))
  }

  excluirExistente(ponto) {
    this.props.excluirPontoEmbarque(ponto.id)
      .then(() => {
        showSuccessMsg('Ponto excluído com sucesso')
        this.carregarPontosExistentes(this.state.cidadeSelecionada.value)
      })
      .catch(() => showAlertMsg('Não foi possível excluir. Este ponto está vinculado a trechos.'))
  }

  iniciarEdicao(ponto) {
    this.setState({ editandoId: ponto.id, textoEdicao: ponto.nome })
  }

  salvarEdicao(ponto) {
    if (!this.state.textoEdicao.trim()) return
    this.props.editarPontoEmbarque(ponto.id, { nome: this.state.textoEdicao.trim() })
      .then(() => {
        showSuccessMsg('Ponto atualizado com sucesso')
        this.setState({ editandoId: null, textoEdicao: '' })
        this.carregarPontosExistentes(this.state.cidadeSelecionada.value)
      })
      .catch(() => showAlertMsg('Erro ao editar ponto de embarque.'))
  }

  render() {
    const { estadoSelecionado, cidadeSelecionada, cidadesOpcoes, textoPonto, pontosNovos, pontosExistentes } = this.state
    return (
      <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
           tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content vx-modal-content">
            <div className="vx-modal-header">
              <div className="vx-modal-header-icon">
                <i className="material-icons">add_location</i>
              </div>
              <div>
                <h5 className="vx-modal-title">Pontos de Embarque</h5>
              </div>
              <button type="button" className="vx-modal-close" onClick={this.props.onFechar}>
                <i className="material-icons">close</i>
              </button>
            </div>

            <div className="vx-modal-body">
              <div className="form-row mb-3">
                <div className="col-12 col-md-6">
                  <label>Estado</label>
                  <Select
                    placeholder="Selecione o estado..."
                    noOptionsMessage={() => 'Nenhuma opção'}
                    options={estados.map(e => ({ value: e.uf, label: `${e.nome}-${e.uf}` }))}
                    value={estadoSelecionado}
                    onChange={opt => this.handleEstado(opt)}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label>Cidade</label>
                  <Select
                    placeholder="Selecione a cidade..."
                    noOptionsMessage={() => 'Selecione um estado primeiro'}
                    options={cidadesOpcoes}
                    value={cidadeSelecionada}
                    onChange={opt => this.handleCidade(opt)}
                    isDisabled={!estadoSelecionado}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  />
                </div>
              </div>

              <div className="form-row align-items-end mb-2">
                <div className="col-12 col-md-8">
                  <label>Ponto de embarque</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ex: Rodoviária Interestadual"
                    value={textoPonto}
                    onChange={e => this.setState({ textoPonto: e.target.value })}
                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); this.incluirPonto() } }}
                  />
                </div>
                <div className="col-12 col-md-4">
                  <button type="button" className="vx-btn-secondary w-100" onClick={() => this.incluirPonto()}>
                    <i className="material-icons" style={{ verticalAlign: 'middle', fontSize: '16px' }}>add</i> Incluir
                  </button>
                </div>
              </div>

              {pontosNovos.length > 0 && (
                <div style={{ background: '#fff8f0', border: '1px solid #FF6A00', borderRadius: '6px', padding: '10px 14px', marginBottom: '12px' }}>
                  <p style={{ fontWeight: '600', fontSize: '12px', color: '#FF6A00', marginBottom: '6px' }}>
                    <i className="material-icons" style={{ fontSize: '14px', verticalAlign: 'middle' }}>pending</i> A salvar:
                  </p>
                  {pontosNovos.map((nome, idx) => (
                    <div key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '3px 0', borderBottom: '1px solid #ffe0c0' }}>
                      <span style={{ fontSize: '13px' }}>{nome}</span>
                      <button type="button" className="vx-btn-icon" onClick={() => this.removerNovo(idx)}>
                        <i className="material-icons" style={{ fontSize: '16px', color: '#e53e3e' }}>close</i>
                      </button>
                    </div>
                  ))}
                </div>
              )}

              {pontosExistentes.length > 0 && (
                <div style={{ borderTop: '1px solid #eee', marginTop: '8px', paddingTop: '10px' }}>
                  <p style={{ fontWeight: '600', fontSize: '12px', color: '#555', marginBottom: '6px' }}>
                    Pontos já cadastrados para esta cidade:
                  </p>
                  <table style={{ width: '100%', fontSize: '13px' }}>
                    <tbody>
                      {pontosExistentes.map(ponto => (
                        <tr key={ponto.id} style={{ borderBottom: '1px solid #f5f5f5' }}>
                          <td style={{ padding: '5px 4px', color: '#888' }}>#{ponto.id}</td>
                          <td style={{ padding: '5px 4px' }}>
                            {this.state.editandoId === ponto.id ? (
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={this.state.textoEdicao}
                                onChange={e => this.setState({ textoEdicao: e.target.value })}
                                onKeyDown={e => { if (e.key === 'Enter') this.salvarEdicao(ponto) }}
                              />
                            ) : ponto.nome}
                          </td>
                          <td style={{ padding: '5px 4px', textAlign: 'right' }}>
                            {this.state.editandoId === ponto.id ? (
                              <>
                                <button type="button" className="vx-btn-icon" onClick={() => this.salvarEdicao(ponto)}>
                                  <i className="material-icons" style={{ fontSize: '16px', color: '#38a169' }}>check</i>
                                </button>
                                <button type="button" className="vx-btn-icon" onClick={() => this.setState({ editandoId: null })}>
                                  <i className="material-icons" style={{ fontSize: '16px', color: '#888' }}>close</i>
                                </button>
                              </>
                            ) : (
                              <>
                                <button type="button" className="vx-btn-icon" title="Editar" onClick={() => this.iniciarEdicao(ponto)}>
                                  <i className="material-icons" style={{ fontSize: '16px', color: '#3182ce' }}>edit</i>
                                </button>
                                <button type="button" className="vx-btn-icon" title="Excluir" onClick={() => this.excluirExistente(ponto)}>
                                  <i className="material-icons" style={{ fontSize: '16px', color: '#e53e3e' }}>delete</i>
                                </button>
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="vx-modal-footer">
              <button type="button" className="vx-btn-secondary" onClick={this.props.onFechar}>Fechar</button>
              <button type="button" className="vx-btn-primary" onClick={() => this.salvar()}
                      disabled={pontosNovos.length === 0 || !cidadeSelecionada}>
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, {
  salvarPontosEmbarque,
  excluirPontoEmbarque,
  editarPontoEmbarque,
  listarPontosEmbarquePorEmpresaCidade
})(ModalCadastrarPontoEmbarque)
